import React, { CSSProperties } from 'react'
import { Image } from 'Components/view-image'
import classNames from 'classnames'
import { GenImgAttrsData } from 'Components/view-image/utils'
import styles from './index.module.scss'

interface IProps {
  src: string
  alt?: string
  className?: string
  style?: CSSProperties
  imgBackground?: string
  cutType?: GenImgAttrsData['cutType']
  percent?: number
}

const FilterBackground: React.FC<IProps> = ({
  src,
  alt,
  className,
  imgBackground,
  style,
  children,
  cutType,
  percent = 50,
}) => {
  return (
    <React.Fragment>
      <div className={classNames('tw-relative', className)} style={style}>
        <div
          className={classNames(
            styles.left,
            'tw-absolute tw-inset-0 tw-overflow-hidden'
          )}
          style={{ background: imgBackground, right: `${percent}%` }}
        >
          <Image
            src={src}
            alt={alt}
            width={600}
            height={300}
            layout="fill"
            className="tw-filter tw-blur-20"
            lazy={false}
            cutType={cutType}
          />
        </div>
        <div
          className={classNames(
            styles.right,
            'tw-absolute tw-inset-0 tw-overflow-hidden'
          )}
          style={{ background: imgBackground, left: `${100 - percent}%` }}
        >
          <Image
            src={src}
            alt={alt}
            width={600}
            height={300}
            layout="fill"
            lazy={false}
            cutType={cutType}
          />
        </div>
        <div className="tw-relative tw-z-10">{children}</div>
      </div>
    </React.Fragment>
  )
}

export default FilterBackground
